import { useState, useEffect } from "react";
import { Modal, Form, Col, Row, Table } from "react-bootstrap";
import api from "../../services/api";
import IcX from "../../components/Svg/IcX";
import styles from "./style.module.css";
import tableStyle from "../../components/Table/Table.module.css";
import { formatDate, toDigits, getMaxQuota } from "../../util/functions";
import DatePicker from "../../components/DatePicker";
import Checkbox from "../../components/Checkbox";
import styleButton from "../Button/Button.module.css";
import { toast } from "react-toastify";
import { Currency, Percent } from "../Input";
import useFormat from "../../hooks/utils/useFormat";
import Results from "../Results";
import useWrapper from "../../hooks/useWrapper";
import SwitchCheckbox from "../SwitchCheckBox";

const ModalReboleto = props => {
  const { title, show, closeModal, boleto, reload, setReload } = props;
  const value_total = (boleto?.value || 0) + (boleto?.value_juros || 0);
  const { formatReal, stringToDate } = useFormat();

  const { config } = useWrapper();
  const [reboleto, setReboleto] = useState({
    quota: "",
    quotas: [],
    interval: null,
  });
  const [beforeEvent, setbeforeEvent] = useState(null);
  useEffect(() => {
    (async () => {
      if (boleto) {
        const response = await api.get(`commercial/${boleto.commercial.id}`, config);
        let max_quota = getMaxQuota(response.data);
        let before_event = stringToDate(response?.data?.date_end);
        setbeforeEvent(before_event);
        let quotasVar = [];
        for (let i = 0; i < max_quota; i++) {
          quotasVar.push({
            label: `${i + 1}x`,
            value: i + 1,
          });
        }
        setReboleto({
          quota: "",
          quotas: [],
          issue: new Date(),
          interval: null,
        });
      }
    })();
    // config is recreated every render; effect is intentionally keyed to boleto only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boleto, stringToDate]);

  useEffect(() => {
    if (!show) {
      setReboleto({
        quota: 0,
        quotas: [],
        total: 0,
        interval: null,
      });
    }
  }, [show]);

  useEffect(() => {
    let quotasVar = [];

    for (let i = 0; i < reboleto.quota; i++) {
      let interval_date = new Date(
        reboleto.issue.getFullYear(),
        reboleto.interval !== null ? reboleto.issue.getMonth() : reboleto.issue.getMonth() + i,
        reboleto.interval !== null ? reboleto.issue.getDate() + reboleto.interval * i : reboleto.issue.getDate(),
      );
      let first_event = beforeEvent;

      quotasVar.push({
        date: interval_date > first_event ? null : interval_date,
        value_raw: value_total / reboleto.quota,
        value: (value_total + reboleto?.tax_value) / reboleto.quota,
        label: `${i + 1}ª Parcela`,
        description: "",
        editable: false,
        ...(!!reboleto?.tax_value && {
          tax: reboleto?.tax_value,
          tax_description: reboleto?.tax_desc,
        }),
      });
    }
    setReboleto(r => ({
      ...r,
      quotas: quotasVar,
      edit_sum: 0,
      not_edit: r.quota,
    }));
  }, [
    reboleto?.quota,
    reboleto?.tax_value,
    reboleto?.tax_desc,
    reboleto.issue,
    reboleto.interval,
    beforeEvent,
    value_total,
  ]);

  useEffect(() => {
    setReboleto(r => ({
      ...r,
      quotas: r.quotas.map((e, i) => {
        let interval_date = new Date(
          r.issue.getFullYear(),
          r.interval !== null ? r.issue.getMonth() : r.issue.getMonth() + i,
          r.interval !== null ? r.issue.getDate() + r.interval * i : r.issue.getDate(),
        );
        let first_event = beforeEvent;

        return {
          ...e,
          date: interval_date > first_event ? null : interval_date,
        };
      }),
    }));
  }, [reboleto.issue, reboleto.interval, beforeEvent]);

  useEffect(() => {
    let edit_sum = 0;
    let not_edit = 0;
    reboleto.quotas.forEach(e => {
      if (e.editable) {
        edit_sum += parseFloat(e.value);
      } else {
        not_edit++;
      }
    });
    setReboleto(r => ({
      ...r,
      edit_sum: edit_sum,
      not_edit: not_edit,
    }));
  }, [reboleto.quotas]);

  useEffect(() => {
    setReboleto(r => {
      let reboleto_quotasVar = [...r.quotas];

      reboleto_quotasVar.forEach((e, index) => {
        if (!e.editable) {
          reboleto_quotasVar[index] = {
            ...e,
            value: (value_total + (r?.tax_value || 0) - r.edit_sum) / r.not_edit,
            value_raw: (value_total - r.edit_sum) / r.quota,
          };
        }
      });
      return {
        ...r,
        quotas: reboleto_quotasVar,
      };
    });
  }, [reboleto.edit_sum, reboleto.not_edit, value_total]);

  const sendReboleto = () => {
    api
      .post(
        `/paymentslips/reboleto/${boleto.id}`,
        {
          newBoletos: reboleto.quotas.map((e, index) => ({
            type_payment: "cartao",
            value: e.value,
            value_raw: e.value_raw,
            due_date: e.date,
            description: e.description,
            quotas: index + 1,
            total_quotas: reboleto.quotas.length,
            entry: false,
            editable: true,
            commercial_id: boleto.commercial.id,
            trainee_id: boleto.trainee.id,
            cost_center_id: null,
            expense_plan_id: null,
            expense_id: null,
            payment_slip_id: boleto.id,
            status: "nao-gerado",
          })),
        },
        config,
      )
      .then(() => {
        closeModal();
        setReload(!reload);
        toast.success("Renegociação de Boleto gerado com sucesso!");
      });
  };

  return (
    <Modal size="lg" show={show} onHide={closeModal}>
      <Form>
        <Modal.Header>
          <div as="label" className="d-flex w-100">
            <h2 className="page-title">{title}</h2>
          </div>
          <button type="button" className={styles.closeModal} onClick={closeModal}>
            <IcX />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Table className={`mb-0 ${tableStyle.table}`}>
                <thead>
                  <tr>
                    <th>Formando</th>
                    <th>Valor</th>
                    <th>Vencimento</th>
                    <th>Parcela</th>
                    <th>Código</th>
                  </tr>
                </thead>
                {boleto && (
                  <tbody>
                    <tr className="show_desc">
                      <td className={tableStyle.strong}>{boleto.trainee.name}</td>
                      <td>{formatReal(value_total)}</td>
                      <td>{formatDate(boleto.due_date, 7)}</td>
                      <td>
                        {boleto.quota}/{boleto.quotas_total}
                      </td>
                      <td>{toDigits(boleto.id, 6)}</td>
                    </tr>
                  </tbody>
                )}
              </Table>
            </Col>
          </Row>
          <div className="divisor mb-4"></div>
          <Row>
            <Col>
              <span className="lince-input_label">Parcelamento</span>
              <Form.Control
                type="text"
                value={reboleto.quota}
                onChange={e => {
                  if (e.target.value < 100) {
                    setReboleto({
                      ...reboleto,
                      quota: e.target.value,
                    });
                  }
                }}
              />
            </Col>
            <Col>
              <span className="lince-input_label">Primeira Parcela</span>
              {beforeEvent && (
                <DatePicker
                  selected={reboleto.issue}
                  minDate={new Date()}
                  maxDate={!reboleto.ignore_date ? beforeEvent : null}
                  changeDate={e => {
                    setReboleto({
                      ...reboleto,
                      issue: e,
                    });
                  }}
                />
              )}
            </Col>
            <Col>
              <Form.Group className="lince-input checkbox-input">
                <span className="lince-input_label">Intervalo</span>
                <Form.Control
                  type="text"
                  // onChange={event => handleValueString(event, 'tel')}
                  value={reboleto.interval === null ? "Mensal" : reboleto.interval}
                  onChange={e => {
                    setReboleto({
                      ...reboleto,
                      interval: e.target.value,
                    });
                  }}
                  disabled={reboleto.interval === null}
                />
                <Form.Check.Label className="im-checkbox">
                  <Checkbox
                    checked={reboleto.interval !== null}
                    onChange={e => {
                      if (e.target.checked) {
                        setReboleto({
                          ...reboleto,
                          interval: 30,
                        });
                      } else {
                        setReboleto({
                          ...reboleto,
                          interval: null,
                        });
                      }
                    }}
                  />
                  <span className="fs-12">Em Dias</span>
                </Form.Check.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-2 mt-2">
            <Col sm={4}>
              <div>
                <span className="lince-input_label">Taxas</span>
                <Percent
                  value={reboleto.tax}
                  name="reboleto.tax"
                  valueChange={ev => {
                    setReboleto({
                      ...reboleto,
                      tax: ev || "",
                      tax_value: value_total * (ev * 0.01) || 0,
                    });
                  }}
                />
              </div>
            </Col>
            {!!reboleto.tax && (
              <Col sm={8}>
                <div>
                  <span className="lince-input_label">Descrição da Taxa</span>
                  <Form.Control
                    value={reboleto.tax_desc}
                    name="reboleto.tax_desc"
                    onChange={ev => {
                      setReboleto({
                        ...reboleto,
                        tax_desc: ev.target.value,
                      });
                    }}
                  />
                </div>
              </Col>
            )}
          </Row>
          <Row className="mb-2">
            <Col>
              <p className="small-label m-0">
                Boletos só podem ser emitidos com vencimento até o dia da Última Parcela. (
                <b>{formatDate(beforeEvent, 7)}</b>)
              </p>
              <Form.Group className="d-block" style={{ marginTop: ".333rem", marginBottom: ".5rem" }}>
                <SwitchCheckbox
                  label="Ignorar Data do Primeiro Evento"
                  checked={reboleto.ignore_date}
                  onChange={__ev => {
                    setReboleto({
                      ...reboleto,
                      ignore_date: __ev.target.checked,
                    });
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          {reboleto.quotas.length > 0 && (
            <Row className="mt-3">
              <Col>
                <Table className={tableStyle.table}>
                  <thead>
                    <tr>
                      <th width={90}>Rótulo</th>
                      <th>Valor</th>
                      <th>Editar</th>
                      <th>Data de Vencimento</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reboleto.quotas.map((rb, index) => (
                      <tr>
                        <td>{rb.label}</td>
                        <td>
                          <Currency
                            value={rb.value || ""}
                            disabled={!rb.editable}
                            valueChange={ev => {
                              if (rb.editable) {
                                let reboleto_quotasVar = [...reboleto.quotas];
                                let input_value = !ev ? "0" : ev;

                                let sum_others_edit = 0;
                                reboleto_quotasVar.forEach((r, r_index) => {
                                  if (index !== r_index && r.editable) {
                                    sum_others_edit += parseFloat(r.value);
                                  }
                                });
                                let sum = sum_others_edit + parseFloat(input_value);
                                if (sum <= value_total + (reboleto?.tax_value || 0)) {
                                  reboleto_quotasVar[index].value = input_value;
                                  setReboleto({
                                    ...reboleto,
                                    quotas: reboleto_quotasVar,
                                  });
                                } else {
                                  setReboleto({
                                    ...reboleto,
                                  });
                                }
                              }
                            }}
                          />
                        </td>
                        <td className="text-center">
                          <Checkbox
                            checked={rb.editable}
                            onChange={e => {
                              let remaining = 0;
                              remaining = reboleto.quotas.filter(e => !e.editable);

                              if (remaining.length > 1 || e.target.checked === false) {
                                let reboleto_quotasVar = [...reboleto.quotas];
                                reboleto_quotasVar[index].editable = e.target.checked;

                                setReboleto({
                                  ...reboleto,
                                  quotas: reboleto_quotasVar,
                                });
                              }
                            }}
                          />
                        </td>
                        <td>
                          <DatePicker
                            selected={rb.date}
                            changeDate={e => {
                              let reboleto_quotasVar = [...reboleto.quotas];
                              reboleto_quotasVar[index].date = e;
                              setReboleto({
                                ...reboleto,
                                quotas: reboleto_quotasVar,
                              });
                            }}
                            minDate={new Date()}
                            maxDate={!reboleto.ignore_date ? beforeEvent : null}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="text"
                            value={rb.description}
                            onChange={e => {
                              let reboleto_quotasVar = [...reboleto.quotas];
                              reboleto_quotasVar[index].description = e.target.value;
                              setReboleto({
                                ...reboleto,
                                quotas: reboleto_quotasVar,
                              });
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          )}
          <Row>
            <Col md={{ span: 7, offset: 5 }}>
              <Results
                rows={[
                  {
                    label: "Valor do Boleto",
                    value: formatReal(value_total || 0),
                    type: "dark",
                  },
                  {
                    label: "Taxas",
                    value: formatReal(reboleto?.tax_value || 0),
                  },
                  {
                    label: <b>Total</b>,
                    value: <b>{formatReal(value_total + (reboleto?.tax_value || 0))}</b>,
                    type: true ? "dark" : "",
                  },
                ]}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button
            className={styleButton.button_primary}
            type="button"
            disabled={!reboleto.quotas.length > 0 && "true"}
            onClick={() => {
              sendReboleto();
            }}
          >
            <span>
              Gerar Novo{reboleto.quotas.length > 1 && "s"} Boleto{reboleto.quotas.length > 1 && "s"}
            </span>
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalReboleto;
